"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _UpgradeModal = _interopRequireDefault(require("ui-addon-upgrades/decorators/UpgradeModal"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _UILock = _interopRequireDefault(require("ui-addon-upgrades/icons/UILock"));

var _underscore = require("underscore");

var OPEN_TRACKING_DELAY_MS = 50;

function sequence() {
  for (var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    handlers.forEach(function (handler) {
      return handler && handler.apply(void 0, args);
    });
  };
}

var getChildOptionsWithLockBadges = function getChildOptionsWithLockBadges(options) {
  return options && options.map(function (option) {
    // grouped option
    if (option.options) {
      return (0, _extends2.default)({}, option, {
        options: getChildOptionsWithLockBadges(option.options)
      });
    }

    return (0, _extends2.default)({}, option, {
      badge: option.locked && _react.default.createElement(_UILock.default, null) || undefined
    });
  });
};

var LockedSelectFeatures =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(LockedSelectFeatures, _React$Component);

  function LockedSelectFeatures(props) {
    var _this;

    (0, _classCallCheck2.default)(this, LockedSelectFeatures);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LockedSelectFeatures).call(this, props));
    _this.state = {
      lockVerified: false
    };
    _this.blockNextOnChange = false;
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOpen = _this.handleOpen.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSelectedOptionChange = _this.handleSelectedOptionChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.debouncedHandleOpen = (0, _underscore.debounce)(_this.handleOpen, OPEN_TRACKING_DELAY_MS);
    return _this;
  }

  (0, _createClass2.default)(LockedSelectFeatures, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this2 = this;

      return {
        sendLockVerification: function sendLockVerification() {
          _this2.setState({
            lockVerified: true
          });
        }
      };
    }
  }, {
    key: "handleChange",
    value: function handleChange(originalChange, evt) {
      if (originalChange && !this.blockNextOnChange) {
        originalChange(evt);
      } // don't block more than one onChange call


      this.blockNextOnChange = false;
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      var _this3 = this;

      var upgradeData = this.props.upgradeData;
      tracker.track('lockedFeatureInteraction', (0, _extends2.default)({
        action: 'viewed'
      }, upgradeData));
      (0, _underscore.defer)(function () {
        var lockVerified = _this3.state.lockVerified;

        if (!lockVerified) {
          _devLogger.default.warn({
            message: 'LockedSelectFeatures: UILock not detected in children',
            key: 'LockedSelectFeatures'
          });
        }
      });
    }
  }, {
    key: "handleSelectedOptionChange",
    value: function handleSelectedOptionChange(handleClick, evt) {
      var upgradeData = this.props.upgradeData;
      var option = evt.target.value;

      if (option.locked) {
        this.blockNextOnChange = true;
        tracker.track('lockedFeatureInteraction', (0, _extends2.default)({
          action: 'clicked'
        }, upgradeData));
        handleClick();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          children = _this$props.children,
          upgradeData = _this$props.upgradeData,
          modalKey = _this$props.modalKey;
      return _react.default.createElement("span", null, _react.default.createElement(_UpgradeModal.default, {
        upgradeData: upgradeData,
        modalKey: modalKey
      }, function (_ref) {
        var handleClick = _ref.handleClick,
            handleMouseOver = _ref.handleMouseOver;
        return _react.default.Children.map(children, function (child) {
          return _react.default.cloneElement(child, {
            onMouseOver: function onMouseOver() {
              if (child.props.onMouseOver) {
                var _child$props;

                (_child$props = child.props).onMouseOver.apply(_child$props, arguments);
              }

              handleMouseOver();
            },
            onChange: function onChange(evt) {
              return _this4.handleChange(children.props.onChange, evt);
            },
            onOpen: sequence(_this4.debouncedHandleOpen, children.props.onOpen),
            onSelectedOptionChange: sequence(function (evt) {
              return _this4.handleSelectedOptionChange(handleClick, evt);
            }, children.props.onSelectedOptionChange),
            options: getChildOptionsWithLockBadges(children.props.options)
          });
        });
      }));
    }
  }]);
  return LockedSelectFeatures;
}(_react.default.Component);

LockedSelectFeatures.propTypes = {
  modalKey: _react.PropTypes.string.isRequired,
  upgradeData: _react.PropTypes.object.isRequired,
  children: _react.PropTypes.node.isRequired
};
LockedSelectFeatures.childContextTypes = {
  sendLockVerification: _react.PropTypes.func
};
var _default = LockedSelectFeatures;
exports.default = _default;
module.exports = exports.default;